import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { setupAdminUser } from '../utils/setupAdmin';
import { useNotificationHelpers } from '../components/NotificationSystem';
import LoadingSpinner from '../components/EnhancedLoadingSpinner';

const SetupAdmin: React.FC = () => {
  const [email, setEmail] = useState('admin@avis.com');
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const { showSuccess, showError } = useNotificationHelpers();

  const handleSetupAdmin = async () => {
    if (!user) {
      showError('Error', 'You must be logged in to set up admin profile');
      return;
    }

    setIsLoading(true);
    try {
      await setupAdminUser(user.email || '', user.uid);
      showSuccess('Success', 'Admin profile has been set up successfully! Please refresh the page.');
    } catch (error: any) {
      console.error('Setup admin error:', error);
      showError('Setup Failed', error.message || 'Failed to set up admin profile');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Setup Admin Profile</h1>
          <p className="text-gray-600">
            Your account exists but needs admin privileges to be set up.
          </p>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-avis-blue focus:border-avis-blue"
              placeholder="admin@avis.com"
            />
          </div>

          <button
            onClick={handleSetupAdmin}
            disabled={isLoading}
            className="w-full bg-avis-blue text-white py-3 rounded-lg font-semibold hover:bg-avis-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
          >
            {isLoading ? (
              <LoadingSpinner size="sm" text="Setting up..." />
            ) : (
              <span>Setup Admin Profile</span>
            )}
          </button>

          <div className="text-center">
            <p className="text-sm text-gray-500">
              This will create an admin profile for your account in Firestore.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupAdmin;
